import * as types from "../actions/types";
import { createTypes } from "../actions/createTypes";

const initialState = {
  language: "",
  isLoading: false,
}

export default function userLanguage (state=initialState, action={}){ 
  switch(action.type){ 
    case createTypes(types.USER_LANGUAGE).success:
      return { ...state, ...action.payload, isLoading: false }
    case createTypes(types.USER_LANGUAGE).loading:
      return { ...state, isLoading: true }
    default:
      return state
  }
}
